export function SecondsToHHMMSS(seconds: number): string {
  const HH: number = Math.floor(seconds / 3600);
  const MM: number = Math.floor((seconds - HH * 3600) / 60);
  const SS: number = seconds - HH * 3600 - MM * 60;
  return `${HH >= 10 ? HH : '0' + HH.toString()}:${MM >= 10 ? MM : '0' + MM.toString()}:${
    SS >= 10 ? SS : '0' + SS.toString()
  }`;
}

export function SecondsToMMSS(seconds: number): string {
  const MM: number = Math.floor(seconds / 60);
  const SS: number = seconds - MM * 60;
  return `${MM >= 10 ? MM : '0' + MM.toString()}:${SS >= 10 ? SS : '0' + SS.toString()}`;
}

export function HHMMSSToSeconds(HHMMSS: string): string {
  const values = HHMMSS.split(':');
  return `${parseInt(values[0]) * 3600 + parseInt(values[1]) * 60 + parseInt(values[2])}`;
}
